"use client";

import React from "react";
import Image from "next/image";
import Link from "next/link";
import InstagramIcon from "../ui/InstagramIcon";
import BlueskyIcon from "../ui/BlueskyIcon";
import MailingListSignupForm from "@/app/components/ui/MailingListSignupForm";

const Footer: React.FC = () => {
  return (
    <footer className="bg-widertalk-navy text-white py-8 mt-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 items-start gap-6">
          {/* Logo and Brand */}
          <div className="flex items-center gap-3">
            <Image
              src="/white_logo.svg"
              alt="WiderTalk Logo"
              width={120}
              height={120}
              style={{ width: '120px', height: 'auto' }}
            />
          </div>

          {/* Mailing list signup */}
          <div className="md:col-span-2">
            <h3 className="text-base font-semibold mb-2" style={{ fontFamily: 'Inter, "Helvetica Neue", Arial, sans-serif' }}>
              Join our mailing list
            </h3>
            <p className="text-sm text-gray-300 mb-3" style={{ fontFamily: 'Inter, "Helvetica Neue", Arial, sans-serif' }}>
              Get updates on new features, events and highlights.
            </p>
            <MailingListSignupForm layout="inline" buttonLabel="Subscribe" className="max-w-xl" />
          </div>

          {/* Legal Links */}
          <div className="flex items-center gap-4 text-sm justify-center md:justify-end">
            <Link
              href="/terms-and-conditions"
              className="text-gray-300 hover:text-white transition-colors duration-200"
              style={{ fontFamily: 'Inter, "Helvetica Neue", Arial, sans-serif' }}
            >
              Terms & Conditions
            </Link>
            <span className="text-gray-500">|</span>
            <Link
              href="/privacy-policy"
              className="text-gray-300 hover:text-white transition-colors duration-200"
              style={{ fontFamily: 'Inter, "Helvetica Neue", Arial, sans-serif' }}
            >
              Privacy Policy
            </Link>
          </div>

          {/* Social Links */}
          <div className="flex items-center gap-4 justify-center md:justify-end">
            <a
              href="https://bsky.app/profile/widertalk.bsky.social"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-3 py-2 bg-white/10 hover:bg-white/20 rounded-lg transition-all duration-200 hover:scale-105"
              aria-label="Follow us on Bluesky"
              style={{ fontFamily: 'Inter, "Helvetica Neue", Arial, sans-serif' }}
            >
              <BlueskyIcon size={20} className="text-white" />
              <span className="text-sm font-medium text-white">Bluesky</span>
            </a>
            <a
              href="https://instagram.com/widertalk"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-3 py-2 bg-white/10 hover:bg-white/20 rounded-lg transition-all duration-200 hover:scale-105"
              aria-label="Follow us on Instagram"
              style={{ fontFamily: 'Inter, "Helvetica Neue", Arial, sans-serif' }}
            >
              <InstagramIcon size={20} className="text-white" />
              <span className="text-sm font-medium text-white">Instagram</span>
            </a>
          </div>
        </div>
        {/* Copyright */}
        <div className="text-center md:text-right mt-6">
          <p
            className="text-sm text-gray-300"
            style={{ fontFamily: 'Inter, "Helvetica Neue", Arial, sans-serif' }}
          >
            Copyright © 2025 WIDERTALK LTD. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
